import React, { Component } from 'react'
import { Icon } from 'antd'

export default class Details extends Component<any, any> {
    state = {
        open: false
    }
    toggleVisibility = () => {
        this.setState(prevState => ({ open: !prevState.open }))
    }
    render() {
        const { open } = this.state
        const { speciality, company, city, street, house, shaban, initial_doctor, phone } = this.props
        let { scheduler } = this.props
        scheduler = JSON.parse(scheduler)
        return (
            <div style={{ cursor: 'pointer' }}>
                <div style={{ textDecoration: 'underline' }} onClick={() => this.toggleVisibility()}>
                    <Icon type={open ? 'down' : 'left'} style={{ fontSize: '0.8rem', marginLeft: '0.5rem' }} />
                    <span>
                        {speciality} - {company}. {city} {street} {house} {shaban ? ' - שב"ן' : ''}
                        {initial_doctor ? ' - ראשוני' : ''}
                    </span>
                </div>
                <div
                    style={{
                        display: `${this.state.open ? 'flex' : 'none'}`,
                        paddingRight: '1.5rem',
                        flexDirection: 'column'
                    }}
                >
                    <div style={{ opacity: `${scheduler ? '1' : '0.3'}` }}>
                        <strong>שעות פתיחה:</strong>
                        <br />
                        {scheduler
                            ? scheduler.map((hours, index) => (
                                  <div key={index}>
                                      <span style={{ fontWeight: '600' }}>
                                          יום
                                          {
                                              {
                                                  1: 'ראשון',
                                                  2: 'שני',
                                                  3: 'שלישי',
                                                  4: 'רביעי',
                                                  5: 'חמישי',
                                                  6: 'שישי',
                                                  7: 'שבת'
                                              }[hours.day]
                                          }
                                          :
                                      </span>
                                      <span>
                                          {hours.openingHour} - {hours.closingHour}
                                      </span>
                                  </div>
                              ))
                            : '--'}
                    </div>
                    <div style={{ opacity: `${phone ? '1' : '0.3'}` }}>
                        <strong>מספר טלפון: </strong> {phone ? phone : '--'}
                    </div>
                </div>
            </div>
        )
    }
}
